import React from 'react';
import {Controller} from 'react-hook-form';
import {FormGroup, Label, Input} from 'reactstrap';
import {t} from "i18next";
import ElementWithAccessInCountries from '../../../lib/utils/hocs/ElementWithAccessInCountries';

const ExperienceSelectField = ({control, name = "sailing_experience", label}) => {
    return (
        <FormGroup>
            <Label for={name}>{label || t('management.users.experience')}</Label>
            <Controller
                name={name}
                control={control}
                render={({ value, onChange }) => (
                    <Input
                        type="select"
                        id={name}
                        value={value}
                        onChange={onChange}
                    >
                        <option value={''} disabled>{t('management.users.experience')}</option>
                        <option value={'0/7'}>{t('management.users.sailingExperience.0/7')}</option>
                        <option value={'1/7'}>{t('management.users.sailingExperience.1/7')}</option>
                        <option value={'2/7'}>{t('management.users.sailingExperience.2/7')}</option>
                        <ElementWithAccessInCountries hideInCountries={['EN']}>
                            <>
                                <option value={'3/7'}>{t('management.users.sailingExperience.3/7')}</option>
                                <option value={'4/7'}>{t('management.users.sailingExperience.4/7')}</option>
                                <option value={'5/7'}>{t('management.users.sailingExperience.5/7')}</option>
                                <option value={'6/7'}>{t('management.users.sailingExperience.6/7')}</option>
                                <option value={'7/7'}>{t('management.users.sailingExperience.7/7')}</option>
                            </>
                        </ElementWithAccessInCountries>
                    </Input>
                )}
            />
        </FormGroup>
    );
};

export default ExperienceSelectField;